import {HttpClient} from "@angular/common/http";
import {Component, ElementRef, OnInit, ViewChildren} from "@angular/core";
// import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators
} from "@angular/forms";
import {CookieService} from "ngx-cookie-service";
import {Message} from "primeng/primeng";
import {BreadcrumbService} from "../../../../breadcrumb.service";
import {Globals} from "../../../../globals/Globals";
import {RouterConst} from "../../../../globals/RoutersConst";
import {ClientsService} from "../../../../services/clients/clients.service";
import {DashboardDataService} from "../../../../services/dashboard-data.service";
import {HttpService} from "../../../../services/http.service";
import {ShareService} from "../../../../services/share.service";
import {StyleService} from "../../../../services/style.service";
import {WsService} from "../../../../services/websocket/WsService";
import {SuperClass} from "../../../../superclass/SuperClass";
import {TabComponent} from "../tabs/tab.component";
import { CaptivePortal } from '../cp-add-update/cp.model';


declare let $: any;

@Component({
  selector: "cp-designer",
  templateUrl: "./designer.component.html",
  styleUrls: ["./designer.component.scss"]
})
export class DesignerComponent extends SuperClass implements OnInit{
  activeTab: any;
  title = "app";
  myTemplate;
  selectedTemplate;
  newTemplateName;
  copyingTemplate;
  cloneToClient;
  clientList;
  templateName = "";
  msgs: Message[] = [];
  templatesList;
  templateIDInfo = {};
  allPages;
  savedGlobalColor;
  savedGlobalImage;
  headerBackground;
  visible;
  borderWidth = this.styleService.borderWidth;
  borderRadius = this.styleService.borderRadius;
  logoPositionOpts = this.styleService.logoPositionOpts;
  allBackgrounds;
  globalSelectedFont;
  globalPrimaryBackgrounds;
  templateType;
  templateTypes: any[];
  globalLogoPosition;
  isLoaded;
  selectedDevice = false;
  selDevice;
  styleFont: any;
  allFonts;
  previewContent;

  newTemplateForm: FormGroup;
  cloneTemplateForm: FormGroup;
  // activatedTab = true;
  percentage = 0;
  isLoadingImage;

  cpList: CaptivePortal[];

  generalContent: any[] = [
    {
      id: "content_video",
      name: "Video"
    },
    {
      id: "content_image",
      name: "Image"
    },
    {
      id: "content_iframe",
      name: "IFrame"
    }
  ];
  selectedContent;
  selectedNasid;
  selectedLang;
  selectedView;
  locales;

  @ViewChildren("appTabs") appTabs: ElementRef;

  constructor(
    private breadcrumbService: BreadcrumbService,
    private shareService: ShareService,
    private uploadFileService: HttpService,
    private styleService: StyleService,
    private dashboardDataService: DashboardDataService,
    private clientsService: ClientsService,
    private wsService: WsService,
    private httpClient: HttpClient,
    private cookiesService: CookieService,
    private fb: FormBuilder,
    private httpService: HttpService,
    private elRef: ElementRef, // private _sanitizer: DomSanitizer
  ) {
    super(
      clientsService,
      wsService,
      dashboardDataService,
      httpClient,
      cookiesService
    );

    // this.isSaved = false;
    this.breadcrumbService.setItems([
      {label: "Organization"},
      {label: "Captive Portal"},
      {
        label: "CP Designer",
        routerLink: [{outlets: {sub: [RouterConst.DESIGNER]}}]
      }
    ]);
  }

  reloadData() {
    this.http_getTemplateNames((data: any) => {
      this.templatesList = data.payload;
    });
    this.http_getAllCp((data: any) => {
      this.cpList = data.payload;
    });
    // this.http_getAllLocales((data: any) => {
    //   if (data.result === Globals.RESPONSE_RESULT_SUCCESS) {
    //     this.locales = data.payload;
    //   }
    // });
    this.http_getDefTemplateNames((data: any) => {
      if (data.result === Globals.RESPONSE_RESULT_SUCCESS) {
        this.templateTypes = data.payload;
      }
    });

    this.newTemplateForm = this.fb.group({
      name: new FormControl("", Validators.required),
      type: new FormControl("", Validators.required)
    });

    this.cloneTemplateForm = this.fb.group({
      name: new FormControl("", Validators.required),
      clientId: new FormControl("")
    });
  }

  ngOnInit() {
    super.ngOnInit();
    // get all tabs from tabs.component
    this.shareService._tabActive.subscribe(data => {
      this.activeTab = data;
    });
    this.httpService
      .get(Globals.SERVER_ADDR + "/cp/background/getAll")
      .subscribe((data: any) => {
        this.allBackgrounds = data.payload;
      });
    // get api
    this.httpService
      .get(Globals.SERVER_ADDR + "/cp/fonts/getAll")
      .subscribe((data: any) => {
        this.allFonts = data.payload;
        this.styleService.fontOpts.forEach(f =>
          this.allFonts.push({fileName: f.name})
        );
        // console.log('test', data);
      });
  }

  selectedPortalCode(a) {
    this.selectedNasid = a.value.nasid;
    this.http_getAllLocales((data: any) => {
      if (data.result === Globals.RESPONSE_RESULT_SUCCESS) {
        this.locales = data.payload;
        this.locales = JSON.parse(JSON.stringify(data.payload))
          .filter(function (i,n){return i.cpLocaleCode===a.value.cpLocaleCode;})
          .filter(function (p, i, self) {return self.indexOf(self.find(t => t.languageCode === p.languageCode)) === i;});
      }
    });
  }

  selectedLangeage(a){
    this.selectedLang = a.value.languageCode;
  }

  changeSecondaryBackgroundImg(e) {
    const allPages = $(".parentBlock").find(".main-content-container");
    for (let i = 0; i < allPages.length; i++) {
      allPages[i].style.background =
        "url('" + e.value.imageUrl + "')";
    }
  }

  changePrimaryBackgroundImg(e) {
    const allPages = $(".parentBlock").find("#cp");
    for (let i = 0; i < allPages.length; i++) {
      allPages[i].style.background =
        "url('" + e.value.imageUrl + "')";
    }
  }

  setSelectedView(event){
    this.selectedView = event;
  }

  selectDevice(device: string) {
    this.selDevice = device;
    let view = document.querySelector("#cp." + this.selectedView.viewId);
    let body = {
      viewId: this.selectedView.viewId,
      templateId: this.selectedView.templateId,
      innerHTML : view.outerHTML
    }

    this.http_getPreviewHtml(body, this.selectedNasid, this.selectedLang, (data:any) => {
      this.previewContent = data.payload;
      this.selectedDevice = true;
    })
  }

  // activTab(a) {
  //   if(a.target.innerHTML == 'Splash page') {
  //     this.activatedTab = true;
  //   } else {
  //     this.activatedTab = false;
  //   }
  // }

  closePreview() {
    this.selectedDevice = false;
  }

  onSave(msg) {
    //this.msgs = [];
    this.refreshTemplatesList();
    //this.msgs.push(msg);
  }

  selectTemplate(e) {
    this.isLoaded = true;
    this.http_getTemplateData(e, (data: any) => {
      this.myTemplate = data.payload;
      this.templateName = data.payload.name;
      this.isLoaded = false;
      // this.myTemplate.views[0].innerHTML =
      //   '<div id="frame" class="viewable" style="width: 560px; height: 315px"><iframe width="560" height="315" style="pointer-events: none" src="https://www.youtube.com/embed/Y-JQ-RCyPpQ" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>' +
      //   this.myTemplate.views[0].innerHTML;

      setTimeout(() => {
        this.allPages = document.querySelectorAll("#cp");
        this.setTab(this.activeTab.first);
      }, 100);
      this.templateIDInfo = {
        id: data.payload.id,
        clientId: data.payload.clientId
      };
    });
  }

  getClientList() {
    if (!this.clientList)
      this.http_getAllClients((data: any) => {
        this.clientList = data.payload;
      });
  }

  cloneTemplate() {
    const requestBody = {
      name: this.cloneTemplateForm.controls['name'].value,
      id: this.selectedTemplate.id,
      clientId: this.cloneToClient ?
        this.cloneTemplateForm.controls['clientId'].value.clientId :
        undefined
    };

    this.http_cloneAndGetTemplate(requestBody, (data: any) => {
      this.myTemplate = data.payload;
      this.templateName = data.payload.name;
      setTimeout(() => {
        this.allPages = document.querySelectorAll("#cp");
        this.setTab(this.activeTab.first);
      }, 100);
      this.templateIDInfo = {
        id: data.payload.id,
        clientId: data.payload.clientId
      };
      this.refreshTemplatesList();
      document.getElementById("cloneTemplate").click();
      this.showSuccessMessage("Template has been cloned");
    });

  }

  addNewTemplate(templateName) {
    const requiredFields = [
      {
        id: "new-template-input",
        value: this.newTemplateName,
        fieldName: "Template name"
      },
      {
        id: "new-template-dropdown",
        value: this.templateType,
        fieldName: "Template type"
      }
    ];
    if (this.hasEmptyFields(requiredFields)) {
      return;
    }

    const requestBody = {
      name: templateName,
      id: this.templateType.id
    };

    this.http_createAndGetTemplate(requestBody, (data: any) => {
      this.myTemplate = data.payload;
      this.templateName = data.payload.name;
      setTimeout(() => {
        this.allPages = document.querySelectorAll("#cp");
        this.setTab(this.activeTab.first);

      }, 100);
      this.templateIDInfo = {
        id: data.payload.id,
        clientId: data.payload.clientId
      };
      this.refreshTemplatesList();
      document.getElementById("addNewTemplate").click();
      this.showSuccessMessage("New Template has been created");
    });
  }

  refreshTemplatesList() {
    this.http_getTemplateNames((response: any) => {
      this.templatesList = response.payload;
      this.selectedTemplate = this.templatesList.filter(
        template => template.id === this.myTemplate.id
      )[0];
    });
  }

  selectContentToView(e) {
    this.selectedContent = e.value;

    const contents = document.getElementsByClassName("contentview") as any;
    let i;
    for (i = 0; i < contents.length; i++) {
      contents[i].style.display = "none";
    }
    for (i = 0; i < contents.length; i++) {
      if (contents[i].id === e.value.id) contents[i].style.display = "block";
    }
  }

  setTab(tab: TabComponent) {
    this.activeTab.toArray().forEach(taba => (taba.active = false));
    tab.active = true;

    const selectedView = this.myTemplate.views.find(
      view => view.viewName === tab["title"]
    );

    this.selectedView = selectedView;
    this.loadImg(this.activeTab.first, "#logo_id", "logo");
    if (!selectedView.withVideo) {
      this.loadImg(this.activeTab.first, "#login_image_id_1", "splashImage");
    }
    let selector = document.getElementById("generalContentSelector") as any;
    if (selector !== undefined) {
      this.selectContentToView({
        value: this.generalContent[1]
      });
    }
    // if(tab.title == 'Splash page') {
    //   this.activatedTab = true;
    // } else {
    //   this.activatedTab = false;
    // }
    return tab;
  }

  changePageType(e, viewId) {
    this.myTemplate.views[
      this.myTemplate.views.findIndex(view => view.viewId === viewId)
      ].withVideo = e;
  }

  changePrimaryBackground(e) {
    const allPages = $(".parentBlock").find("#cp");
    for (let i = 0; i < allPages.length; i++) {
      allPages[i].style.background = e;
    }
    this.savedGlobalColor = e;
  }

  changeSecondaryBackground(e) {
    const allPages = $(".parentBlock").find(".main-content-container");
    for (let i = 0; i < allPages.length; i++) {
      allPages[i].style.background = e;
    }
    this.savedGlobalColor = e;
  }

  changeGlobalTextColor(e) {
    const allPages = $(".parentBlock").find("p, label");
    for (let i = 0; i < allPages.length; i++) {
      allPages[i].style.color = e;
    }
    this.savedGlobalColor = e;
  }

  changeHeaderBackground(e) {
    const allPages = $(".parentBlock").find(".page-header");
    for (let i = 0; i < allPages.length; i++) {
      allPages[i].style.background = e;
    }
    this.savedGlobalColor = e;
  }

  changeHeaderTextColor(e) {
    const allPages = $(".parentBlock .page-header").find("p, label");
    for (let i = 0; i < allPages.length; i++) {
      allPages[i].style.color = e;
    }
    this.savedGlobalColor = e;
  }

  changeFooterBackground(e) {
    const allPages = $(".parentBlock").find(".page-footer");
    for (let i = 0; i < allPages.length; i++) {
      allPages[i].style.background = e;
    }
    this.savedGlobalColor = e;
  }

  changeFooterTextColor(e) {
    const allPages = $(".parentBlock .page-footer").find("p, label");
    for (let i = 0; i < allPages.length; i++) {
      allPages[i].style.color = e;
    }
    this.savedGlobalColor = e;
  }

  changeInputsBackground(e) {
    const allInputs =
      ':input[type="text"], :input[type="email"], :input[type="password"], :input[type="tel"], #voucher_code';
    const allPages = $(".main-content-container").find(allInputs);
    for (let i = 0; i < allPages.length; i++) {
      allPages[i].style.background = e;
    }
    this.savedGlobalColor = e;
  }

  changeBannerBackground(e) {
    const allPages = $(".parentBlock").find(".page-banner-container");
    for (let i = 0; i < allPages.length; i++) {
      allPages[i].style.background = e;
    }
    this.savedGlobalColor = e;
  }

  changeBannerTextColor(e) {
    const allPages = $(".parentBlock").find(".page-banner-container");
    for (let i = 0; i < allPages.length; i++) {
      allPages[i].style.color = e;
    }
    this.savedGlobalColor = e;
  }

  changeGlobalFontFamily(e) {
    const allPages = $(".parentBlock").find("p, label, .bodytext, .cpt-button");
    for (let i = 0; i < allPages.length; i++) {
      allPages[i].style.fontFamily = e.value.fileName;
    }
    if (!e.value.fontUrl) return;

    this.styleFont = `<style class="style">@font-face {font-family: "${
      e.value.fileName
      }";src: url("${
      e.value.fontUrl
      }") format("woff2"),url("${
      e.value.fontUrl
      }") format("woff");}</style>`;
    let addStyle: any = document.querySelectorAll("#cp");
    let style = document.querySelectorAll(".style");

    for (let i = 0; i < addStyle.length; i++) {
      if ($(addStyle[i]).children(".style").length > 0) {
        for (let i = 0; i < style.length; i++) {
          addStyle[i].removeChild(style[i]);
        }
      }
      addStyle[i].innerHTML += this.styleFont;
    }
  }

  changeInputsBorderColor(e) {
    const allInputs =
      ':input[type="text"], :input[type="email"], :input[type="password"], :input[type="tel"], #voucher_code';
    const allPages = $(".main-content-container").find(allInputs);
    for (let i = 0; i < allPages.length; i++) {
      allPages[i].style.borderColor = e;
    }
    this.savedGlobalColor = e;
  }

  changeGlobalBorder(e) {
    const allInputs =
      ':input[type="text"], :input[type="email"], :input[type="password"], :input[type="tel"], #voucher_code';
    const allPages = $(".main-content-container").find(allInputs);
    for (let i = 0; i < allPages.length; i++) {
      allPages[i].style.borderWidth = e.value.value + "px";
    }
  }

  changeGlobalBorderRadius(e) {
    const allInputs =
      ':input[type="text"], :input[type="email"], :input[type="password"], :input[type="tel"], #voucher_code';
    const allPages = $(".main-content-container").find(allInputs);
    for (let i = 0; i < allPages.length; i++) {
      allPages[i].style.borderRadius = e.value.value + "px";
    }
  }

  changeLogoPosition(e) {
    const allPages = $(".logo-container");
    for (let i = 0; i < allPages.length; i++) {
      allPages[i].style.justifyContent = e.value.value;
    }
  }

  getCurrTemplate() {
    return this.myTemplate;
  }

  unselectRow() {
  }

  getWebSocketIdentifier(): string {
    return undefined;
  }

  getPercentage(e) {
    this.percentage = e;
    setTimeout(() => {
      this.percentage = 0;
    }, 2000);
  }

  getImageLoadingState(e) {
    this.isLoadingImage = e;
  }

  private loadImg(tab, id, tag) {
    const currTemplate = this.getCurrTemplate();
    const currView = currTemplate.views.filter(function (el) {
      return el.viewName === tab["title"];
    })[0];
    const src = document.querySelectorAll(id);
    $("#login_iframe_id_2 #remove_id_2").css("display", "block");
    $("#login_iframe_id_1 #remove_id_1").css("display", "block");
    this.uploadFileService
      .getFiles(currView.viewId, tag, currTemplate.id)
      .subscribe(data => {
        for (let i = 0; i < src.length; i++) {
          src[i].setAttribute(
            "src",
            "data:image/JPEG;base64," + `${data.payload.img}`
          );
        }
      });
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/organization/captive-portal/cp-designer/designer.component.ts